import { render, staticRenderFns } from "./ConsignmentNotesRegistries.vue?vue&type=template&id=5a8d471f&scoped=true&"
import script from "./ConsignmentNotesRegistries.vue?vue&type=script&lang=js&"
export * from "./ConsignmentNotesRegistries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8d471f",
  null
  
)

export default component.exports